"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelSubmittedOrder = exports.submitOrder = exports.verifyWavesAuthData = exports.verifyAuthData = exports.verifyCustomData = exports.verify = exports.serialize = exports.signTx = exports.txTypeMap = void 0;
const marshall_1 = require("@waves/marshall");
const ts_lib_crypto_1 = require("@waves/ts-lib-crypto");
const request_1 = __importDefault(require("@waves/node-api-js/cjs/tools/request"));
const stringify_1 = __importDefault(require("@waves/node-api-js/cjs/tools/stringify"));
const issue_1 = require("./transactions/issue");
const transfer_1 = require("./transactions/transfer");
const reissue_1 = require("./transactions/reissue");
const burn_1 = require("./transactions/burn");
const lease_1 = require("./transactions/lease");
const cancel_lease_1 = require("./transactions/cancel-lease");
const data_1 = require("./transactions/data");
const mass_transfer_1 = require("./transactions/mass-transfer");
const alias_1 = require("./transactions/alias");
const set_script_1 = require("./transactions/set-script");
const generic_1 = require("./generic");
const set_asset_script_1 = require("./transactions/set-asset-script");
const exchange_1 = require("./transactions/exchange");
const sponsorship_1 = require("./transactions/sponsorship");
const invoke_script_1 = require("./transactions/invoke-script");
const custom_data_1 = require("./requests/custom-data");
const auth_1 = require("./requests/auth");
const wavesAuth_1 = require("./requests/wavesAuth");
const ts_types_1 = require("@waves/ts-types");
const update_asset_info_1 = require("./transactions/update-asset-info");
const invoke_expression_1 = require("./transactions/invoke-expression");
exports.txTypeMap = {
    [ts_types_1.TRANSACTION_TYPE.ISSUE]: { sign: (x, seed) => issue_1.issue(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.TRANSFER]: { sign: (x, seed) => transfer_1.transfer(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.REISSUE]: { sign: (x, seed) => reissue_1.reissue(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.BURN]: { sign: (x, seed) => burn_1.burn(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.LEASE]: { sign: (x, seed) => lease_1.lease(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.CANCEL_LEASE]: { sign: (x, seed) => cancel_lease_1.cancelLease(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.ALIAS]: { sign: (x, seed) => alias_1.alias(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.MASS_TRANSFER]: { sign: (x, seed) => mass_transfer_1.massTransfer(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.DATA]: { sign: (x, seed) => data_1.data(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.SET_SCRIPT]: { sign: (x, seed) => set_script_1.setScript(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.SET_ASSET_SCRIPT]: { sign: (x, seed) => set_asset_script_1.setAssetScript(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.SPONSORSHIP]: { sign: (x, seed) => sponsorship_1.sponsorship(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.EXCHANGE]: { sign: (x, seed) => exchange_1.exchange(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.INVOKE_SCRIPT]: { sign: (x, seed) => invoke_script_1.invokeScript(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.UPDATE_ASSET_INFO]: { sign: (x, seed) => update_asset_info_1.updateAssetInfo(x, seed) },
    [ts_types_1.TRANSACTION_TYPE.INVOKE_EXPRESSION]: { sign: (x, seed) => invoke_expression_1.invokeExpression(x, seed) },
};
/**
 * Signs arbitrary transaction. Can also create signed transaction if provided params have type field
 * @param tx
 * @param seed
 */
function signTx(tx, seed) {
    if (!exports.txTypeMap[tx.type])
        throw new Error(`Unknown tx type: ${tx.type}`);
    return exports.txTypeMap[tx.type].sign(tx, seed);
}
exports.signTx = signTx;
/**
 * Converts transaction or order object to Uint8Array
 * @param obj transaction or order
 */
function serialize(obj) {
    if (generic_1.isOrder(obj))
        return marshall_1.binary.serializeOrder(obj);
    return marshall_1.binary.serializeTx(obj);
}
exports.serialize = serialize;
/**
 * Verifies signature of transaction or order
 * @param obj
 * @param proofN - proof index. Takes first proof by default
 * @param publicKey - takes senderPublicKey by default
 */
function verify(obj, proofN = 0, publicKey) {
    publicKey = publicKey || obj.senderPublicKey;
    const bytes = serialize(obj);
    const signature = obj.version == null ? obj.signature : obj.proofs[proofN];
    return ts_lib_crypto_1.verifySignature(publicKey, bytes, signature);
}
exports.verify = verify;
function verifyCustomData(data) {
    const bytes = custom_data_1.serializeCustomData(data);
    return ts_lib_crypto_1.verifySignature(data.publicKey, bytes, data.signature);
}
exports.verifyCustomData = verifyCustomData;
function verifyAuthData(authData, params, chainId) {
    chainId = chainId || 'W';
    const bytes = auth_1.serializeAuthData(params);
    const myAddress = ts_lib_crypto_1.address({ publicKey: authData.publicKey }, chainId);
    return myAddress === authData.address && ts_lib_crypto_1.verifySignature(authData.publicKey, bytes, authData.signature);
}
exports.verifyAuthData = verifyAuthData;
function verifyWavesAuthData(authData, params, chainId) {
    chainId = chainId || 'W';
    const bytes = wavesAuth_1.serializeWavesAuthData(params);
    const myAddress = ts_lib_crypto_1.address({ publicKey: authData.publicKey }, chainId);
    return myAddress === authData.address && ts_lib_crypto_1.verifySignature(authData.publicKey, bytes, authData.signature);
}
exports.verifyWavesAuthData = verifyWavesAuthData;
function submitOrder(ord, opts) {
    let endpoint, matcherUrl;
    if (typeof opts === 'string') {
        matcherUrl = opts;
        endpoint = 'matcher/orderbook';
    }
    else {
        matcherUrl = opts.matcherUrl;
        endpoint = opts.market ? 'matcher/orderbook/market' : 'matcher/orderbook';
    }
    return request_1.default({
        base: matcherUrl,
        url: endpoint,
        options: { method: 'POST', body: stringify_1.default(ord), headers: { 'Content-Type': 'application/json' } },
    });
}
exports.submitOrder = submitOrder;
/**
 * Sends cancel order command to matcher. Since matcher api requires amountAsset and priceAsset in request url,
 * this function requires them as params
 * @param co - signed cancelOrder object
 * @param amountAsset - amount asset of the order to be canceled
 * @param priceAsset - price asset of the order to be canceled
 * @param matcherUrl - matcher address to send order cancel to. E.g. https://matcher.waves.exchange/
 */
function cancelSubmittedOrder(co, amountAsset, priceAsset, matcherUrl) {
    const endpoint = `matcher/orderbook/${amountAsset || 'WAVES'}/${priceAsset || 'WAVES'}/cancel`;
    return request_1.default({
        base: matcherUrl,
        url: endpoint,
        options: { method: 'POST', body: stringify_1.default(co), headers: { 'Content-Type': 'application/json' } },
    });
}
exports.cancelSubmittedOrder = cancelSubmittedOrder;
//# sourceMappingURL=general.js.map